import { FC, Fragment } from "react";
import { InputLabel } from "@material-ui/core";
import { ChangeNames } from "../../clients/FirebaseClient/types";
import { useFormModel } from "../core/FormModelHelpes";
import { NumberInput } from "../core/NumberField";
import { useStyles } from "../../useStyles";
import { BoxedInputWithIconAndOptionalSwitch } from "../core/BoxedInputWithIconAndOptionalSwitch";
import { BuildingIcon } from "../core/icons/Icons";
import { Switch } from "../core/Switch";

export const IncreaseExpectedElectricBusinessDemandForm: FC = () => {
    const classes = useStyles();
    const { values, setValues, getFieldProps } =
        useFormModel<ChangeNames.INCREASE_EXPECTED_ELECTRIC_BUSINESS_DEMAND>();

    return (
        <Fragment>
            <BoxedInputWithIconAndOptionalSwitch
                icon={<BuildingIcon />}
                useSwitch={
                    <Switch
                        checked={values.increaseExpectedElectricBusinessDemand.value.installed}
                        {...getFieldProps("adjustableLoadElectricBoiler.value.installed")}
                        onChange={(e, checked) =>
                            setValues((values) => {
                                values.increaseExpectedElectricBusinessDemand.value.installed =
                                    checked;
                                values.increaseExpectedElectricBusinessDemand.value.demand.amount =
                                    checked ? 0 : null;
                            })
                        }
                    />
                }
                detailCondition={values.increaseExpectedElectricBusinessDemand.value.installed}
                content={
                    <Fragment>
                        <p className={classes.label} style={{ marginBottom: 8 }}>
                            Gleichzeitig benötigte Gewerbeleistung
                        </p>
                        <p className={classes.p} style={{ marginTop: 0, marginBottom: 24 }}>
                            Geben Sie die gleichzeitig benötigte Gewerbeleistung an. Die benötigte
                            Leistung erhalten Sie ggf. von Ihrem Elektroinstallateur.
                        </p>
                    </Fragment>
                }
                detail={
                    <Fragment>
                        <InputLabel className={classes.labledTextfieldLabel}>
                            Summe der Gewerbeleistung
                        </InputLabel>
                        <NumberInput
                            className={classes.textField}
                            decimalScale={
                                values.increaseExpectedElectricBusinessDemand.value.demand.precision
                            }
                            allowLeadingZeros={false}
                            allowNegative={false}
                            thousandSeparator="."
                            decimalSeparator=","
                            adornment={
                                values.increaseExpectedElectricBusinessDemand.value.demand.unit
                            }
                            value={
                                values.increaseExpectedElectricBusinessDemand.value.demand.amount ||
                                ""
                            }
                            placeholder="0"
                            onValueChange={(v) =>
                                setValues((values) => {
                                    values.increaseExpectedElectricBusinessDemand.value.demand.amount =
                                        v.floatValue || null;
                                })
                            }
                            error={
                                values.increaseExpectedElectricBusinessDemand.error ? true : false
                            }
                        />
                    </Fragment>
                }
            />
        </Fragment>
    );
};
